import {FieldValues} from 'react-hook-form';
import Title from '@/components/help/common/Title';
import {FormGroup} from '@/components/help/common/FormContainer';
import {ILLEGAL_FIELD_ORDER, FORM_TYPE_ILLEGAL} from '@/constants/help/index';
import ReportIllegalNotice from './ReportIllegalNotice';
import {useFormDefaultFieldValues} from '@/hooks/help/useFormDefaultValues';
import {useSubmitForm} from '@/hooks/help/useSubmitForm';

const HelpReportIllegal = () => {
  const defaultFieldValues = useFormDefaultFieldValues({
    type: FORM_TYPE_ILLEGAL,
  });

  const {mutate: postHelpForm} = useSubmitForm({type: FORM_TYPE_ILLEGAL});

  const onSubmit = (data: FieldValues) => {
    const submissionData = {...data};

    const illegalContent = [
      `1) 신고·요청자이름(기관·단체명): ${submissionData.reporterName}`,
      `2) 생년월일(기관·법인번호): ${submissionData.birth}`,
      `3) 휴대폰 번호: ${submissionData.phoneNumber}`,
      `4) 신고 내용: ${submissionData.content}`,
    ].join('\n');

    submissionData.content = illegalContent;

    postHelpForm(submissionData);
  };

  return (
    <>
      <Title title='불법촬영물등 유통 신고' />
      <ReportIllegalNotice />
      <FormGroup
        onSubmit={onSubmit}
        fieldOrder={ILLEGAL_FIELD_ORDER}
        defaultValues={defaultFieldValues}
        type={FORM_TYPE_ILLEGAL}>
        <FormGroup.UserId />
        <FormGroup.OsInfo />
        <FormGroup.Email />
        <FormGroup.ReporterName />
        <FormGroup.Birth />
        <FormGroup.PhoneNumber />
        <FormGroup.Category />
        <FormGroup.Title />
        <FormGroup.Content />
        <FormGroup.AttachedFiles />
        <FormGroup.CautionBox />
        <FormGroup.Agreement />
        <FormGroup.ActionButtons />
      </FormGroup>
    </>
  );
};

export default HelpReportIllegal;
